// extracted by mini-css-extract-plugin
module.exports = {"item":"Accordion_item__g5CLI","label":"Accordion_label__QTpkj","icon":"Accordion_icon__XO4TP","content":"Accordion_content__amM19","checkbox":"Accordion_checkbox__22Ju4"};